// extracted by mini-css-extract-plugin
module.exports = {"text":"AppDescriptionArea_text__y_rP_","ja-text":"AppDescriptionArea_ja-text__LuGnn","en-text":"AppDescriptionArea_en-text__K8qA6"};